import React from "react";
import Banner from "../../Components/userComponents/Common/Banner";
import OurCommitment from "../../Components/userComponents/CoursesComponents/OurCommitment";
import ContentSection from "../../Components/userComponents/CoursesComponents/ContentSection";

const Courses = () => {
  return (
    <div>
      <Banner page="Courses" path="courses" />
      <OurCommitment />
      <ContentSection />
    </div>
  );
};

export default Courses;
